import React, { useEffect } from 'react';
import Container from 'mf-react-ui/Container';
import { H2, H3, P } from 'mf-react-ui/Typography';
import { BannerSingle } from 'mf-react-ui/Banner';
import { useParams, useHistory, Link as LinkRouter } from 'react-router-dom';
import { scroller, Element } from 'react-scroll';
import { Modals, ModalsState } from '../../features/modals/types';
import { Offers } from '../../types';
import * as images from '../../img';
import { AppRoute } from '../../const';
import { EventCat, EventGTM, EventId, EventName, trackEventBound } from '../../utils/ga';
import './IndexPage.scss';

type Props = {
  offers: Offers;
  showModal: (params: ModalsState) => void;
};

const IndexPage: React.FC<Props> = (props) => {
  const { offers, showModal } = props;
  // @ts-ignore
  const { slug } = useParams();
  const { push } = useHistory();

  useEffect(() => {
    const offer = offers.find((offerItem) => offerItem.partnerSlug === slug);

    if (offer) {
      const { partner, subscriptionOptions } = offer;

      showModal({
        modalType: Modals.SubscriptionOptions,
        modalProps: {
          partner,
          ...subscriptionOptions,
          onClose: () => push(AppRoute.ROOT),
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  const handleBannerButtonClick = (): void => {
    scroller.scrollTo('bannerButtonScrollToElement', {
      duration: 1000,
      delay: 100,
      smooth: true,
    });
    trackEventBound(
      EventGTM.MakeActions,
      EventId.ClickGoToGiftsButton,
      EventCat.Gift,
      EventName.ClickElement,
      'За подарками'
    );
  };

  const handleOfferClick = (partner: string): void => {
    trackEventBound(
      EventGTM.UseNavigations,
      EventId.ClickOffer,
      EventCat.TilesGift,
      EventName.ClickOffer,
      `Выбирайте в подарок впечатления / ${partner}`
    );
  };

  return (
    <>
      <BannerSingle
        className="banner_main"
        title={
          <>
            <span style={{ display: 'block', whiteSpace: 'nowrap' }}>Вещи не вечны, </span>дари
            эмоции!
          </>
        }
        subtitle={
          <>
            Скидки на любимые
            <br /> сервисы до 70%
          </>
        }
        images={{
          s: `${images.bannerImageS} 1x, ${images.bannerImageS2X} 2x, ${images.bannerImageS3X} 3x`,
          m: `${images.bannerImageM} 1x, ${images.bannerImageM2X} 2x, ${images.bannerImageM3X} 3x`,
          l: `${images.bannerImageL} 1x, ${images.bannerImageL2X} 2x, ${images.bannerImageL3X} 3x`,
          xl: `${images.bannerImageXL} 1x, ${images.bannerImageXL2X} 2x, ${images.bannerImageXL3X} 3x`,
        }}
        button={{
          text: 'За подарками',
          view: 'secondary',
          size: 'l',
          onClick: handleBannerButtonClick,
        }}
      />
      <Element className="section-gifts-wrapper" name="bannerButtonScrollToElement">
        <section className="section section_background-dark section-gifts">
          <Container>
            <H2 className="section-gifts__title" align="center">
              Выбирайте в подарок впечатления
            </H2>
            <div className="tile-grid-wrapper">
              <ul className="tile-grid">
                {offers
                  .sort((offerA, offerB) => offerA.position - offerB.position)
                  .map((offer) => {
                    const { id, partner, partnerSlug, image, title, description } = offer;

                    return (
                      <li key={id} className="tile-grid__cell">
                        <LinkRouter
                          to={`${AppRoute.OFFER}/${partnerSlug}`}
                          className="gift-tile"
                          onClick={() => handleOfferClick(partner)}
                        >
                          <div className="gift-tile__image-wrapper">
                            <div className="gift-tile__image-wrapper-inner">
                              <img
                                src={image.split(',')[0]}
                                srcSet={image.split(',').slice(1).join(',')}
                                className="gift-tile__image"
                                alt=""
                              />
                            </div>
                          </div>
                          <div className="gift-tile__content">
                            <H3 className="gift-tile__title">{title}</H3>
                            <P>{description}</P>
                          </div>
                        </LinkRouter>
                      </li>
                    );
                  })}
              </ul>
            </div>
          </Container>
        </section>
      </Element>
    </>
  );
};

export default IndexPage;
